import React, { createContext, useCallback, useState } from 'react';
import type { Editor as TinyMCE } from 'tinymce/tinymce';

export enum EditorCommand {
  MceInsertContent = 'mceInsertContent',
  MceImage = 'mceImage',
  InsertUnorderedList = 'InsertUnorderedList',
  InsertOrderedList = 'InsertOrderedList',
  Delete = 'Delete'
}

interface CurrentEditorContextProps {
  currentEditor: TinyMCE | null;
  setCurrentEditor: React.Dispatch<React.SetStateAction<TinyMCE | null>>;
  execCommand(props: { command: EditorCommand; content?: string }): void;
}

export const CurrentEditorContext = createContext<CurrentEditorContextProps | undefined>(undefined);

export const CurrentEditorProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentEditor, setCurrentEditor] = useState<TinyMCE | null>(null);
  const execCommand: CurrentEditorContextProps['execCommand'] = useCallback(
    ({ command, content }) => currentEditor?.execCommand(command, false, content),
    [currentEditor]
  );
  return (
    <CurrentEditorContext.Provider value={{ currentEditor, setCurrentEditor, execCommand }}>
      {children}
    </CurrentEditorContext.Provider>
  );
};
